/**
 * The Limiter adds a limit to the number of function invocations
 *
 * Once `limiter.execute(aCallback)` is called, subsequent calls to `limiter.execute(aCallback)` will be
 * ignored until a time of `minInterval` elapsed.
 * The last ignored `callback` will be scheduled and will be executed when the duration of `minInterval`
 * elapsed. This allows the Limiter to make sure `callback` is not invoked to often, but the latest `callback`
 * will be invoked finally.
 */
export class Limiter {
    private limited = false;
    private scheduled?: () => any;
    private readonly minInterval: number;

    constructor(minInterval: number) {
        this.minInterval = minInterval;
    }

    public execute(callback: () => any) {
        if (!this.limited) {
            callback();
            this.scheduled = undefined;
            this.limited = true;
            setTimeout(() => {
                this.limited = false;
                if (this.scheduled) {
                    this.scheduled.call(this);
                }
            }, this.minInterval);
        } else {
            this.scheduled = callback;
        }
    }
}
